<div class="add-item-dialog-header"
    style="padding: 30px 24px 0; display: flex; justify-content: space-between; align-items: center;">
    <h1 style="font-size: 24px;">
        New Sender Info
    </h1>
    <button (click)="closeWithoutAddItem()"><i class="fas fa-times" style="font-size: 24px; color: red;"></i></button>
</div>
<div mat-dialog-content>
    <form ngNativeValidate [formGroup]="changeSenderInfoForm">
        <div>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <label class="shippn-form-label">
                        Sender Name
                    </label>
                    <input type="text" formControlName="senderName"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('senderName').touched && changeSenderInfoForm.get('senderName').invalid}"
                        placeholder="" class="form-control form-control-sm shippn-input">
                </div>
                <div class="col-12 col-lg-6">
                    <label class="shippn-form-label">
                        Sender Company
                    </label>
                    <input type="text" formControlName="company"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('company').touched && changeSenderInfoForm.get('company').invalid}"
                        placeholder="" class="form-control form-control-sm shippn-input">
                </div>
                <div class="col-12 col-lg-6" style="margin-top: 10px;">
                    <label class="shippn-form-label">
                        Sender Email
                    </label>
                    <input type="text" formControlName="senderEmail"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('senderEmail').touched && changeSenderInfoForm.get('senderEmail').invalid}"
                        placeholder="" class="form-control form-control-sm shippn-input">
                </div>
                <div class="col-12 col-lg-6" style="margin-top: 10px;">
                    <label class="shippn-form-label">
                        Sender Phone
                    </label>
                    <input type="text" maxlength="35" formControlName="senderPhone"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('senderPhone').touched && changeSenderInfoForm.get('senderPhone').invalid}"
                        placeholder="" class="form-control form-control-sm shippn-input">
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-6" style="margin-top: 10px;">
                    <label class="shippn-form-label">
                        Line 1
                    </label>
                    <input #senderPlacesRef 
                        (onAddressChange)="handleAddressChange($event,'add')" type="text"
                        formControlName="addressLineOne"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('addressLineOne').touched && changeSenderInfoForm.get('addressLineOne').invalid}"
                        placeholder="Address Line 1" class="form-control form-control-sm shippn-input">
                </div>
                <div class="col-12 col-lg-6" style="margin-top: 10px;">
                    <label class="shippn-form-label">
                        Line 2
                    </label>
                    <input type="text" maxlength="35" formControlName="addressLineTwo"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('addressLineTwo').touched && changeSenderInfoForm.get('addressLineTwo').invalid}"
                        placeholder="Address Line 2" class="form-control form-control-sm shippn-input">
                </div>
            </div>
            <div class="row">
                <div style="margin-top: 10px;" class="col-12 col-lg-6">
                    <label class="shippn-form-label">
                        Country
                    </label>
                    <div class="select--wrapper" style="background-color: white; border-radius:5px">
                        <i class="fas fa-chevron-down"
                            style="position: absolute; right: 8px; top: 16px;float: right; color: #222222;font-size: 12px;"
                            aria-hidden="true"></i>
                        <select (change)="changeAddCountry()"
                            [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('country').touched && changeSenderInfoForm.get('country').invalid}"
                            formControlName="country" style="width: 100%; border-radius: 5px;height:42px;"
                            class="form-control-sm">
                            <option value="{{country.code}}" *ngFor="let country of allCountries">
                                <span *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                                <span *ngIf="country.code == 'TR' || country.name == 'Turkey'" translate="no">Türkiye</span>
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-lg-6" style="margin-top: 10px;">
                    <label class="shippn-form-label">
                        Post Code
                    </label>
                    <input type="text" formControlName="postCode"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('postCode').touched && changeSenderInfoForm.get('postCode').invalid}"
                        placeholder="Post Code" class="form-control form-control-sm shippn-input">
                </div>
                <div class="col-12 col-lg-6" style="margin-top: 10px;">
                    <label class="shippn-form-label">
                        State
                    </label>
                    <input type="text" formControlName="state"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('state').touched && changeSenderInfoForm.get('state').invalid}"
                        placeholder="State" class="form-control form-control-sm shippn-input">
                </div>
                <div style="margin-top: 10px;" class="col-12 col-lg-6">
                    <label class="shippn-form-label">
                        City Name
                    </label>
                    <input type="text" formControlName="cityName"
                        [ngClass]="{'shippn-border-red':changeSenderInfoForm.get('cityName').touched && changeSenderInfoForm.get('cityName').invalid}"
                        placeholder="City Name" class="form-control form-control-sm shippn-input">
                </div>
            </div>
        </div>
    </form>
</div>
<div mat-dialog-actions style="justify-content: flex-end;">
    <button mat-flat-button color="primary" class="shippn-mat-btn" (click)="addNewAddress()" cdkFocusInitial>Save
        Changes</button>
</div>